import { tv } from 'tailwind-variants';

export const subPageNavigationVariants = tv({
  slots: {
    container: [],
    nav: 'w-full',
    subNavheader: [],
    list: [
      'flex',
      'flex-col',
      'justify-start',
      'font-medium',
      'text-base',
      'leading-6',
      'text-left',
      'text-textPrimary',
    ],
    listWrapper: [
      'mb-0',
      'text-lg',
      'md:h-auto',
      'text-call-out',
      'leading-4',
      'list-none',
      'font-medium',
    ],
    // Base overrides ButtonWrapper's built-in buttonVariants defaults
    link: ['w-full', 'relative', 'items-center', 'box-border', 'flex!', 'flex-col'],
    chevron: [],
  },
  variants: {
    layout: {
      'tab-layout': {
        list: [
          'gap-1.5',
          'min-[569px]:flex-row',
          'min-[569px]:flex-wrap',
          'justify-start',
          'min-[1000px]:justify-center',
          'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary',
        ],
        link: [
          'hover:no-underline!',
          'hover:border-call-out!',
          'hover:bg-call-out!',
          'hover:text-white!',
          'md:h-23.5',
          'justify-center',
          'min-w-0',
          'overflow-hidden',
          'py-2!',
          'px-[10.400px]!',
          'border!',
          'border-medium-gray',
          'rounded-none!',
          'font-bold!',
          'text-[14px]!',
          'leading-4!',
          'text-center!',
          'text-call-out!',
          'transition-colors!',
          'duration-300!',
          'ease-in-out!',
          'delay-0!',
          'cursor-pointer!',
          'bg-white',
          'h-full',
        ],
        listWrapper: [
          'h-11.25',
          'max-[569px]:w-full!',
          'max-[669px]:w-[32.5%]!',
          'max-[769px]:w-[24%]!',
          'max-[1000px]:w-[19%]!',
          'max-[1200px]:w-[13%]!',
          'min-[1200px]:w-25',
          'min-[569px]:h-25',
        ],
        chevron: 'hidden',
      },
      'link-layout': {
        container: ['bg-[#e9f4f7] md:bg-transparent'],
        nav: ['p-5 rounded-[5px] bg-[#e9f4f7]'],
        subNavheader: [
          'text-[20px] md:text-[22px] font-semibold md:font-medium leading-7.5 md:leading-8.25 text-primary mb-3.75',
        ],
        list: ['md:gap-3', 'md:flex-row', 'md:flex-wrap'],
        listWrapper: ['px-2 md:px-0 bg-white md:bg-transparent'],
        link: [
          'flex!',
          'flex-row',
          'justify-start',
          'bg-transparent',
          'md:bg-white',
          'px-3',
          'text-white',
          'hover:text-white',
          'justify-between',
          'md:justify-center',
          'min-w-0',
          'overflow-hidden',
          'py-2.5',
          'px-3.75',
          'md:p-2.5',
          'md:border',
          'md:border-medium-gray',
          'font-medium!',
          'text-base',
          'md:text-[18px]!',
          'leading-6',
          'md:leading-6.75!',
          'text-left!',
          'text-textPrimary',
          'transition-colors!',
          'duration-300!',
          'ease-in-out!',
          'delay-0!',
          'cursor-pointer!',
          'rounded',
          'cursor-pointer',
        ],
        chevron: '',
      },
    },
    isActive: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      layout: 'tab-layout',
      isActive: true,
      class: {
        link: [
          'bg-call-out',
          'text-white!',
          // Neutralise inherited tab-layout hover effects — active card stays static
          'hover:bg-call-out!',
          'hover:text-white!',
          'hover:border-call-out',
          'border-call-out',
          'cursor-pointer!',
        ],
      },
    },
    {
      layout: 'link-layout',
      isActive: true,
      class: {
        link: [
          'bg-primary!',
          'text-white!',
          'border-t-[3px]!',
          'border-solid!',
          'border-tertiary!',
          'cursor-pointer!',
          'hover:bg-tertiary!',
        ],
        chevron: 'text-white',
      },
    },
  ],
});
